import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '../assets/img/title.png'
import _imports_2 from '../assets/img/prize.png'
import _imports_3 from '../assets/img/gr_btn.png'
import _imports_4 from '../assets/img/gr_btn_none.png'
import _imports_5 from '../assets/img/tt_btn.png'
import _imports_6 from '../assets/img/tt_btn_none.png'
import _imports_7 from '../assets/img/ai_btn.png'
import _imports_8 from '../assets/img/ai_btn_none.png'
import _imports_9 from '../assets/img/rule_btn.png'
import _imports_10 from '../assets/img/record_btn.png'
import _imports_11 from '../assets/img/rank_btn.png'
import _imports_12 from '../assets/img/bottom.png'
import _imports_13 from '../assets/img/rule_title.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "title",
  src: _imports_1,
  alt: "寻路东坡"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "prize",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "tzbtn",
  src: _imports_4,
  alt: "个人挑战赛"
}
const _hoisted_6 = {
  key: 3,
  class: "tzbtn",
  src: _imports_6,
  alt: "团体挑战赛"
}
const _hoisted_7 = {
  key: 5,
  class: "tzbtn",
  src: _imports_8,
  alt: "AI挑战赛"
}
const _hoisted_8 = { class: "btn" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "company",
  src: _imports_12,
  alt: "支持单位"
}, null, -1)
const _hoisted_10 = { class: "rule" }
const _hoisted_11 = { class: "rule-content" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "rule-title",
  src: _imports_13,
  alt: "活动规则"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (!_ctx.isIndividualEnd)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          class: "tzbtn",
          src: _imports_3,
          alt: "个人挑战赛",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleStart(false)))
        }))
      : (_openBlock(), _createBlock("img", _hoisted_5)),
    (_ctx.activityData.templateConfig.isOpenTeam && _ctx.isTeamShow)
      ? (_openBlock(), _createBlock("img", {
          key: 2,
          class: "tzbtn",
          src: _imports_5,
          alt: "团体挑战赛",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleStart(true)))
        }))
      : _createCommentVNode("", true),
    (!_ctx.activityData.templateConfig.isOpenTeam || !_ctx.isTeamShow)
      ? (_openBlock(), _createBlock("img", _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.isAiShow)
      ? (_openBlock(), _createBlock("img", {
          key: 4,
          class: "tzbtn",
          src: _imports_7,
          alt: "AI挑战赛",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleStart(false, 'ai')))
        }))
      : _createCommentVNode("", true),
    (!_ctx.isAiShow)
      ? (_openBlock(), _createBlock("img", _hoisted_7))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      _createVNode("img", {
        src: _imports_9,
        alt: "活动规则",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowRule = true))
      }),
      _createVNode("img", {
        src: _imports_10,
        alt: "中奖记录",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleStart(false, 'prize')))
      }),
      _createVNode("img", {
        src: _imports_11,
        alt: "排行榜",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onRank && _ctx.onRank(...args)))
      })
    ]),
    _hoisted_9,
    _withDirectives(_createVNode("div", _hoisted_10, [
      _createVNode("div", {
        class: "rule-layer",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowRule = false))
      }),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", {
          class: "rule-body",
          innerHTML: _ctx.activityData.templateConfig.desc
        }, null, 8, ["innerHTML"])
      ])
    ], 512), [
      [_vShow, _ctx.isShowRule]
    ])
  ]))
}